import { gql } from "@apollo/client";

export const MARK_BELL_NOTIFICATION_READ = gql`
    mutation bellNotificationMarkRead($id: ID!) {
        bellNotificationMarkRead(id: $id) {
            ok
        }
    }
`;

export const MARK_BELL_NOTIFICATION_READ_ALL = gql`
    mutation bellNotificationMarkAllRead {
        bellNotificationMarkAllRead {
            ok
        }
    }
`;
